import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AppState {
  isSideNavCollapsed: boolean;
  isMobile: boolean;
  toggleSideNav: () => void;
  setSideNavCollapsed: (collapsed: boolean) => void;
  setIsMobile: (isMobile: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      isSideNavCollapsed: false,
      isMobile: false,
      toggleSideNav: () =>
        set((state) => ({ isSideNavCollapsed: !state.isSideNavCollapsed })),
      setSideNavCollapsed: (collapsed) => set({ isSideNavCollapsed: collapsed }),
      setIsMobile: (isMobile) => set({ isMobile }),
    }),
    {
      name: 'ls-app-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isSideNavCollapsed: state.isSideNavCollapsed,
      }),
    }
  )
);
